/**
 * SweetAlert2 toast/dialog wrapper used across admin islands.
 */
export default function adminAlert(message, icon = 'success', options = {}) {
    const Swal = window.Swal;
    if (!Swal || !message) {
        return Promise.resolve();
    }

    return Swal.fire({
        text: message,
        icon,
        buttonsStyling: false,
        timer: icon === 'success' && !options.showConfirmButton ? 2200 : undefined,
        showConfirmButton: options.showConfirmButton ?? icon !== 'success',
        confirmButtonText: options.confirmButtonText || 'Ok',
        customClass: {
            confirmButton: icon === 'error' ? 'btn btn-danger' : 'btn btn-primary',
            container: options.containerClass,
        },
    });
}
